// extracted by mini-css-extract-plugin
export default {"container":"Create_container__Ykvhw","card":"Create_card__5-vc2"};